import React from 'react';
import PropTypes from 'prop-types';
import './FormField.css';

const FormField = ({ label, name, type = 'text', value, onChange, error, helperText, required, options, ...rest }) => {
  const isInvalid = !!error;
  const id = `field-${name}`;

  return (
    <div className="form-field">
      <label htmlFor={id} className="form-field__label">
        {label} {required && <span className="form-field__required" aria-hidden="true">*</span>}
      </label>
      
      {type === 'select' ? (
        <select
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          className={`form-field__input ${isInvalid ? 'form-field__input--error' : ''}`}
          aria-invalid={isInvalid}
          aria-describedby={isInvalid ? `${id}-error` : helperText ? `${id}-helper` : undefined}
          required={required}
          {...rest}
        >
          <option value="">Select...</option>
          {options?.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      ) : type === 'textarea' ? (
        <textarea
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          className={`form-field__input form-field__textarea ${isInvalid ? 'form-field__input--error' : ''}`}
          aria-invalid={isInvalid}
          aria-describedby={isInvalid ? `${id}-error` : helperText ? `${id}-helper` : undefined}
          required={required}
          {...rest}
        />
      ) : (
        <input
          id={id}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          className={`form-field__input ${isInvalid ? 'form-field__input--error' : ''}`}
          aria-invalid={isInvalid}
          aria-describedby={isInvalid ? `${id}-error` : helperText ? `${id}-helper` : undefined}
          required={required}
          {...rest}
        />
      )}

      {isInvalid && <p id={`${id}-error`} className="form-field__error" role="alert">{error}</p>}
      {!isInvalid && helperText && <p id={`${id}-helper`} className="form-field__helper">{helperText}</p>}
    </div>
  );
};

FormField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  }))
};

export default FormField;
